import script from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterModal.vue?vue&type=script&setup=true&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=eda85636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eda85636"]])

export default __exports__